import { MODULE } from '@careconne/core/configs';
import { environment } from '@careconne/environments/environment';

export const APP_CONFIG = {
  module: MODULE.careconne,
  apiBaseUrl: environment.apiBaseUrl,
  tokenApiUrl: environment.tokenApiUrl,
  inActiveTime: 30,
};
